import React from 'react';
import SpecialAccessInvitesSection from '../components/SpecialAccessInvitesSection';

export default function SpecialAccessInvitesPage() {
  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <div>
          <h1 className="admin-page__title" style={{ fontSize: '22px', fontWeight: 750, letterSpacing: '-0.02em' }}>
            Special Access Invites
          </h1>
          <p className="admin-page__subtitle" style={{ margin: '6px 0 0', fontSize: '13px' }}>
            Invite someone by email so they can create their own owner account.
          </p>
        </div>
      </div>

      <SpecialAccessInvitesSection showHeader={false} />
    </div>
  );
}
